import React,{ useState, useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Popup } from '../../../../components/Popup'
import { Box, Text } from '../../../../designSystem'
import { AccountContext } from '../../../../providers/accountProvider'
import { emailContentGenerator } from '../../../../lib/utils'

const BackToHomeLink = styled(Link)`
    display: block;
    text-align: center;
    width: max-content;
    margin: 8px auto;
    cursor: pointer;
    color: var(--storm-text-storm-500) !important;
`
const MailLink = styled.a`
    text-decoration: None;
    color: var(--Azure500);
`

const DisabledNovelPopup = ({ setIsPopupShown, bookId, ...props }) => {
    const [isPopupOpen,setIsPopupOpen] = useState(true)
    const { user } = useContext(AccountContext)
    const onClose = () => {
        setIsPopupOpen(false)
        if (setIsPopupShown) {
            setIsPopupShown(false)
        }
    }
    const mailContent = emailContentGenerator(user, bookId)
    return (
        <>
        <Popup show={isPopupOpen} close={onClose} disableAutoHide>
           <Box variant="flex" pt={8} pb={8} pr={[16,24]} pl={[16,24]} flexDirection="column">
                <Text variant="titleSecondary" textAlign="center" pt={24}>We have removed the content from the platform as it doesn’t meet our content guidelines. If any concerns, please reach out to us at 
                    <MailLink href={mailContent}> writers@pocketfm.com </MailLink>
                </Text>
                <Box backgroundColor="rgba(242, 198, 2, 0.16)" mt={24} borderRadius={4}>
                    <Text fontSize={16} p={8} fontWeight="s" textAlign="center" color="#ae8701">Please note: We have zero-tolerance policy for copied content in the platform</Text>
                </Box>
                <BackToHomeLink to="/home">Go back to home</BackToHomeLink>
            </Box>
        </Popup>
        </>
    )
}

export default DisabledNovelPopup
